import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import Modal from '../Modal'
import styles from './DashboardExportModal.module.scss'
import Button from '../../Button/Button'
import CheckBox from '@/shared/components/CheckBox/CheckBox'
import DatePicker from '@/shared/components/DatePicker/DatePicker'

interface DashboardExportModalProps {
  isOpen: boolean
  onClose: () => void
}

function DashboardExportModal(props: DashboardExportModalProps) {
  const { isOpen, onClose } = props
  const { t } = useTranslation()

  // const {
  //   totalSalesCountGeneralReport,
  //   totalSalesValueAverageGeneralReport,
  //   totalSalesValueGeneralReport,
  //   topByUnitsDishesReport,
  //   topByUnitsToppingsReport,
  //   topByUnitsIngredientsMvReport
  // } = useDashboardQuery({
  //   start_date: '2025-09-01',
  //   end_date: '2025-12-01',
  //   first_start_date: '2025-09-01',
  //   first_end_date: '2025-12-01',
  //   second_start_date: '2025-09-01',
  //   second_end_date: '2025-12-01',
  //   ingredient_type_filter: 'weight'
  // })

  const [totalSalesChecked, setTotalSalesChecked] = useState(false)
  const [averageOrderValueChecked, setAverageOrderValueChecked] =
    useState(false)
  const [orderCountsChecked, setOrderCountsChecked] = useState(false)

  const [dishesChecked, setDishesChecked] = useState(false)
  const [toppingsChecked, setToppingsChecked] = useState(false)
  const [ingredientsChecked, setIngredientsChecked] = useState(false)

  const handleOnExportClick = () => {
    // if (totalSalesChecked) {
    //   totalSalesCountGeneralReport.mutate({
    //     start_date: '2025-09-01',
    //     end_date: '2025-12-01'
    //   })
    // }
    // if (averageOrderValueChecked) {
    //   totalSalesValueAverageGeneralReport.mutate({
    //     start_date: '2025-09-01',
    //     end_date: '2025-12-01'
    //   })
    // }
    // if (orderCountsChecked) {
    //   totalSalesValueGeneralReport.mutate({
    //     start_date: '2025-09-01',
    //     end_date: '2025-12-01'
    //   })
    // }
    // if (dishesChecked) {
    //   topByUnitsDishesReport.mutate({
    //     start_date: '2025-09-01',
    //     end_date: '2025-12-01'
    //   })
    // }
    // if (toppingsChecked) {
    //   topByUnitsToppingsReport.mutate({
    //     start_date: '2025-09-01',
    //     end_date: '2025-12-01'
    //   })
    // }
    // if (ingredientsChecked) {
    //   topByUnitsIngredientsMvReport.mutate({
    //     start_date: '2025-09-01',
    //     end_date: '2025-12-01'
    //   })
    // }
  }

  const unselectAll = () => {
    setTotalSalesChecked(false)
    setAverageOrderValueChecked(false)
    setOrderCountsChecked(false)
    setDishesChecked(false)
    setToppingsChecked(false)
    setIngredientsChecked(false)
  }

  return (
    <Modal
      title={t('DASHBOARD.EXPORT_MODAL.TITLE')}
      isOpen={isOpen}
      size="small"
      onClose={onClose}
    >
      <div className={styles.exportModalContainer}>
        <p className={`body-medium ${styles.exportModalDescription}`}>
          {t('DASHBOARD.EXPORT_MODAL.DESCRIPTION')}
        </p>
        <div className={styles.dateSelectorContainer}>
          <DatePicker label={t('COMMON.DATE_RANGE')} />
        </div>
        <div className={styles.checkboxContainer}>
          <p className={`body-medium ${styles.exportModalSubTitle}`}>
            {t('DASHBOARD.EXPORT_MODAL.CHARTS_EXPORT.TITLE')}
          </p>
          <CheckBox
            label={t('DASHBOARD.EXPORT_MODAL.TOTAL_SALES')}
            value={totalSalesChecked}
            onChange={() => setTotalSalesChecked(!totalSalesChecked)}
          />
          <CheckBox
            label={t('DASHBOARD.EXPORT_MODAL.AVERAGE_ORDER_VALUE')}
            value={averageOrderValueChecked}
            onChange={() =>
              setAverageOrderValueChecked(!averageOrderValueChecked)
            }
          />
          <CheckBox
            label={t('DASHBOARD.EXPORT_MODAL.ORDER_COUNTS')}
            value={orderCountsChecked}
            onChange={() => setOrderCountsChecked(!orderCountsChecked)}
          />
        </div>
        <div className={styles.checkboxContainer}>
          <p className={`body-medium ${styles.exportModalSubTitle}`}>
            {t('DASHBOARD.EXPORT_MODAL.TABLE_EXPORT.TITLE')}
          </p>
          <div className={styles.checkboxAndSelectWrapper}>
            <CheckBox
              label={t('DASHBOARD.EXPORT_MODAL.DISHES')}
              value={dishesChecked}
              onChange={() => setDishesChecked(!dishesChecked)}
            />
            <CheckBox
              label={t('DASHBOARD.EXPORT_MODAL.TOPPINGS')}
              value={toppingsChecked}
              onChange={() => setToppingsChecked(!toppingsChecked)}
            />
            <CheckBox
              label={t('DASHBOARD.EXPORT_MODAL.INGREDIENTS')}
              value={ingredientsChecked}
              onChange={() => setIngredientsChecked(!ingredientsChecked)}
            />
          </div>
        </div>
        <div className={styles.exportButtonContainer}>
          <Button
            color="secondary"
            label={t('DASHBOARD.EXPORT_MODAL.UNSELECT_ALL.BUTTON.LABEL')}
            variant="contained"
            onClick={unselectAll}
          />
          <Button
            color="primary"
            label={t('DASHBOARD.EXPORT_MODAL.EXPORT_BUTTON.LABEL')}
            variant="contained"
            onClick={handleOnExportClick}
          />
        </div>
      </div>
    </Modal>
  )
}

export default DashboardExportModal
